import { registerStoreFragments } from '@smx-ui-model/store-fragment';
import { registerModel } from '@smx-ui-model/store-model';
import { useWebEnvironment } from '@smx-ui-relay/hook/use-web-environment';
import { RelayEnvironmentProvider } from 'react-relay';
import { Route, Routes } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';

import { paths } from './common';
import { storeContractorFragments } from './model/store-contractor-fragment';
import { storeContractorModel } from './model/store-contractor-model';
import { StoreContractorModelType } from './model/types';
import { NotFoundPage } from './pages/not-found';
import { SharingDocumentPage } from './pages/sharing-document-page';
import { StartPage } from './pages/start-page';
import TopLayout from './pages/top-layout';
import { PersistentComponent } from './persistent-component-2';
import { EnvironmentConfig } from './relay/environment-config';

registerStoreFragments(storeContractorFragments);
registerModel<StoreContractorModelType>(storeContractorModel);

export const App = () => {
    const { relayEnvironment, isLoading } = useWebEnvironment(EnvironmentConfig);

    if (isLoading) {
        return null;
    }

    return (
        <RelayEnvironmentProvider environment={relayEnvironment!}>
            <BrowserRouter>
                <Routes>
                    <Route path={paths.MAIN} element={<StartPage />} />
                    <Route element={<TopLayout />}>
                        <Route path={paths.DOCUMENT_LIST} element={<PersistentComponent />}>
                            <Route index shouldRevalidate={() => false} element={<SharingDocumentPage />} />
                        </Route>
                    </Route>
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>
        </RelayEnvironmentProvider>
    );
};
